import Template from './'
export default  [
	{
		name: 'Default',

		rtl: Template.KsuOne.ksuOneTemplateRTL,
		ltr: Template.KsuOne.ksuOneTemplate,

	},
	{
		name: 'KSU #1',
		rtl: Template.Default.defaultTemplateRTL,
		ltr: Template.Default.defaultTemplate,

	},
	{
		name: 'KSU #2',

		rtl: Template.KsuTwo.ksuTwoTemplateRtl,
		ltr: Template.KsuTwo.ksuTwoTemplate,
	},
	{
		name: 'KSU #3',
		rtl: Template.KsuThree.ksuThreeTemplateRTL,
		ltr: Template.KsuThree.ksuThreeTemplate,
	},

];